<template>
    <div class="mt-lg-3 mt-1 pt-3 pb-0 px-3">
        <b-card class="card-material" style="max-width: 60rem;">
            <h4>
                <h4>Support</h4>
            </h4>
            <p class="card-text">
                If you have any technical difficulties please feel free to contact us through our email
                <a href="mailto:support@things.al" target="_top">support@things.al</a>.
                <br /> Our staff will be ready to answer any of your questions.
            </p>
        </b-card>
    </div>
</template>

<script>
    export default {
        name: "Help"
    }
</script>

<style scoped>

</style>